const updateObjIf = (condition, value) => {
    return condition ? value : {};
};
const filteredObjValues = (obj) => {
    const final = {};
    for (const [key, value] of Object.entries(obj)) {
        const isEmptyArray = Array.isArray(value) && value.length === 0;
        if (value !== undefined && value !== Number.NaN && !isEmptyArray) {
            final[key] = value;
        }
    }
    return final;
};
const filterFalseObjValues = (obj) => {
    const final = {};
    for (const [key, value] of Object.entries(obj)) {
        if (!!value) {
            final[key] = value;
        }
    }
    return final;
};
function getKeyByValue(keyValuePairs, value) {
    return Object.keys(keyValuePairs).find((key) => keyValuePairs[key] === value);
}
function transformObjectValues(object, type) {
    const transformedObj = {};
    for (const key in object) {
        if (Object.prototype.hasOwnProperty.call(object, key)) {
            const value = object[key];
            if (type === Date) {
                transformedObj[key] = new type(object[key]);
            }
            else if (type === Boolean) {
                transformedObj[key] =
                    value === "true"
                        ? true
                        : value === "false"
                            ? false
                            : undefined;
            }
            else {
                transformedObj[key] = type(value);
            }
        }
    }
    return transformedObj;
}
function getEnumKeyByEnumValue(enumObj, enumValue) {
    return Object.keys(enumObj).find((key) => enumObj[key] === enumValue);
}
function generateObjectFromKeys(keys) {
    return keys.reduce((obj, key) => {
        obj[key] = key;
        return obj;
    }, {});
}
function mergeKeyValue(obj, keyValSepator = " : ", options) {
    return Object.entries(obj)
        .filter(([, v]) => {
        if ((options === null || options === void 0 ? void 0 : options.skipNull) && (v === null || v === undefined))
            return false;
        if ((options === null || options === void 0 ? void 0 : options.skipEmpty) && v === "")
            return false;
        if ((options === null || options === void 0 ? void 0 : options.skipZero) && v === 0)
            return false;
        return true;
    })
        .map(([k, v]) => `${k}${keyValSepator}${v}`);
}

export { filterFalseObjValues, filteredObjValues, generateObjectFromKeys, getEnumKeyByEnumValue, getKeyByValue, mergeKeyValue, transformObjectValues, updateObjIf };
//# sourceMappingURL=object.js.map
